import { Navigate } from 'react-router-dom';

import { useAuth } from '../lib/auth/provider';
import { hasMinRole } from '../lib/auth/roles';

/**
 * Redirects unauthenticated users to /login.
 * In demo mode (VITE_AUTH_ENABLED=false) isAuthenticated is always true.
 */
export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

/**
 * Requires the authenticated user to hold *role* or higher.
 * Unauthenticated → /login.  Insufficient role → /.
 *
 * Usage:
 *   <RequireRole role={AppRole.SUPERADMIN}>
 *     <AdminPage />
 *   </RequireRole>
 */
export function RequireRole({ role, children }: { role: string; children: JSX.Element }) {
  const { isAuthenticated, profile } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (!hasMinRole(profile?.roles ?? [], role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
